import React, { useCallback, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { ActionChip, Button, useOverlay } from '@fs/zion-ui'
import { GroupInviteOverlay } from '@fs/zion-tree-groups'
import { usePendingInvites } from '../../providers/PendingInvitesProvider'

/**
 *
 * @param {*} param0
 * @param {*} any
 * @returns
 */

export default function InviteButton({ children, asActionChip, group, ...buttonProps }) {
  const [t] = useTranslation()
  const hasInviteOverlayBeenOpened = useRef()
  const { refetchInvites } = usePendingInvites()
  const overlay = useOverlay()

  // Auto refresh the pending invites once the invite dialog closes
  useEffect(() => {
    if (!overlay.isOpen && !overlay.transitioning && hasInviteOverlayBeenOpened.current) {
      refetchInvites()
    }
  }, [overlay.isOpen, overlay.transitioning, refetchInvites])

  const handleInviteClick = useCallback(
    (event) => {
      overlay.handleClick(event)
      hasInviteOverlayBeenOpened.current = true
    },
    [overlay]
  )

  return (
    <>
      {!asActionChip ? (
        <Button data-testid="invite-member" linkName="Invite Member" {...buttonProps} onClick={handleInviteClick}>
          {children || t('group-management.invite-member.action')}
        </Button>
      ) : (
        <ActionChip
          data-testid="invite-member"
          linkName="Invite Member"
          {...buttonProps}
          onClick={handleInviteClick}
          label={children || t('group-management.invite-member.action')}
        />
      )}
      <GroupInviteOverlay overlay={overlay} groupId={group.id} groupTypes={group.types} groupName={group.name} />
    </>
  )
}
